import {
  SHOW_USER_FORM,
  DASH_USER_CREATED,
  GET_DASH_USERS,
  GET_ALL_DASH_USERS,
  ASSIGN_PRODUCT_DASH,
  REMOVE_ASSIGN_PRODUCT,
  UPDATE_DASH_USER,
  GET_DASH_BUYERS,
  DASH_BUYER_CREATED,
  UPDATE_DASH_BUYERS,
} from '../actionTypes';

const initalState = {
  dashUsers: [],
  users: [],
  showUserForm: 0,
  totalDashUserPages: 0,
  dashBuyers: [],
  totalDashBuyerPages: 0,
};

const DashUsersReducer = (state = initalState, action) => {
  switch (action.type) {
    case SHOW_USER_FORM: {
      return {
        ...state,
        showUserForm: action.payload,
      };
    }
    case DASH_USER_CREATED: {
      const newUsers = [{ ...action.payload.data }];
      const users = [...newUsers, ...state.dashUsers]
      const newCount = Math.ceil(users.length / action.payload.limit);
      return {
        ...state,
        showUserForm: 0,
        totalDashUserPages: newCount,
        dashUsers: [...users],
      }
    }
    case DASH_BUYER_CREATED: {
      const newUsers = [{ ...action.payload.data }];
      const users = [...newUsers, ...state.dashBuyers]
      const newCount = Math.ceil(users.length / action.payload.limit);
      return {
        ...state,
        showUserForm: 0,
        totalDashBuyerPages: newCount,
        dashBuyers: [...users],
      }
    }
    case GET_DASH_USERS: {
      return {
        ...state,
        dashUsers: action.payload.user,
        totalDashUserPages: action.payload.totalPages,
      };
    }
    case GET_ALL_DASH_USERS: {
      return {
        ...state,
        users: [...action.payload.users],
      };
    }
    case ASSIGN_PRODUCT_DASH: {
      const data = [...action.payload.data];
      const { userId } = action;
      const users = [...state.dashUsers];
      const ind = users.findIndex((itm) => itm.id === userId);
      const managerProducts = [...users[ind].managerProducts];
      const newArr = [];
      data.map((item) => {
        newArr.push({
          id: item.id,
          productId: item.product.id,
          product: item.product,
        })
        return true;
      });

      const managerProductsNew = [...managerProducts, ...newArr];
      users[ind].managerProducts = [...managerProductsNew];
      return {
        ...state,
        showUserForm: false,
        dashUsers: [...users],
      };
    }
    case REMOVE_ASSIGN_PRODUCT: {
      const { payload, productId } = action
      const users = [...state.dashUsers]
      const user = users.find((item) => item.id === payload)
      const ind = users.findIndex((item) => item.id === payload)
      const products = user.managerProducts.filter((item) => item.productId !== productId)
      user.managerProducts = [...products]
      const newUsers = [...users.slice(0, ind), { ...user }, ...users.slice(ind + 1)]
      return {
        ...state,
        dashUsers: [...newUsers],
      }
    }
    case UPDATE_DASH_USER: {
      const users = [...state.dashUsers]
      const { payload } = action
      const user = users.find((item) => item.id === payload.id)
      const ind = users.findIndex((item) => item.id === payload.id)
      const obj = { ...payload };
      const newUsers = [...users.slice(0, ind), { ...user, ...obj }, ...users.slice(ind + 1)]
      return {
        ...state,
        dashUsers: [...newUsers],
      }
    }
    case UPDATE_DASH_BUYERS: {
      const users = [...state.dashBuyers]
      const { payload } = action
      const user = users.find((item) => item.id === payload.id)
      const ind = users.findIndex((item) => item.id === payload.id)
      const newUsers = [...users.slice(0, ind), { ...user, ...payload }, ...users.slice(ind + 1)]
      return {
        ...state,
        dashBuyers: [...newUsers],
      }
    }
    case GET_DASH_BUYERS: {
      return {
        ...state,
        dashBuyers: action.payload.user,
        totalDashBuyerPages: action.payload.totalPages,
      };
    }
    default:
      return state;
  }
};

export default DashUsersReducer;
